<template>
  <div class="filters" ref="filters">
    <div class="filters-head">
      <div class="filters-head-side">
        <button
          class="filter-toggle"
          @click="toggle('toggle')"
          :title="`Filters ${active ? 'uitzetten' : 'aanzetten'}`"
        >
          <awesomeIcon icon="filter" />
          <span class="filter-amount" v-if="activeFilters.length > 0">
            {{ activeFilters.length }}
          </span>
        </button>
        <div class="general-input">
          <operatorInput
            v-if="generalInput && generalInput.operators"
            v-model="generalInput.operator"
            :allowed="generalInput.operators"
            style="margin-right:0;"
            ref="operatorInput"
          />
          <div
            v-if="disableGeneralInput"
            class="hide-general-input operator"
            title="Filters wissen"
            @click="disableGeneralHidden($event)"
          />
        </div>
        <div class="general-input">
          <input
            v-if="generalInput"
            type="text"
            v-model.lazy="generalInput.model"
            placeholder="Zoeken"
            :title="`Zoeken op ${generalInput.title}`"
            @keyup.enter="clear('generalSearch')"
          />
          <div
            v-if="disableGeneralInput"
            class="hide-general-input"
            title="Filters wissen"
            @click="disableGeneralHidden($event)"
          />
        </div>
        <button @click="clear('generalSearch')" title="Zoeken">
          <awesomeIcon icon="search"/>
        </button>
        <button @click="clear('refresh')" title="Huidige pagina verversen">
          <awesomeIcon icon="sync" />
        </button>
      </div>
      <div class="filters-head-side">
        <slot name="headerRight">
          <div v-for="(filter, index) in topbarInputs" :key="index">
            <inputDropdown
              v-if="filter.type === 'dropdown'"
              v-model="filter.model"
              :array="checkAttr(filter, 'array')"
              :displayValue="checkAttr(filter, 'displayValue')"
              :defaultValue="checkAttr(filter, 'defaultValue')"
              :defaultIndex="checkAttr(filter, 'defaultIndex')"
              :displayPostfix="checkAttr(filter, 'displayPostfix')"
              :clearable="checkAttr(filter, 'clearable')"
              :clearedDisplayValue="checkAttr(filter, 'clearedDisplayValue')"
              :scroll="checkAttr(filter, 'scroll')"
              :transparent="checkAttr(filter, 'transparent')"
              :align="checkAttr(filter, 'align')"
              :displayPrefix="checkAttr(filter, 'displayPrefix')"
              :cb="checkAttr(filter, 'cb')"
              :requirements="checkAttr(filter, 'requirements')"
            />
            <multiDropdown
              v-else-if="filter.type === 'multiDropdown'"
              :filterComponent="true"
              v-model="filter.model"
              :filterName="filter.filterName"
              :array="checkAttr(filter, 'array')"
              :displayValue="checkAttr(filter, 'displayValue')"
              :defaultValue="checkAttr(filter, 'defaultValue')"
              :defaultIndex="checkAttr(filter, 'defaultIndex')"
              :displayPostfix="checkAttr(filter, 'displayPostfix')"
              :clearable="checkAttr(filter, 'clearable')"
              :clearedDisplayValue="checkAttr(filter, 'clearedDisplayValue')"
              :scroll="checkAttr(filter, 'scroll')"
              :transparent="checkAttr(filter, 'transparent')"
              :align="checkAttr(filter, 'align')"
              :displayPrefix="checkAttr(filter, 'displayPrefix')"
              :cb="checkAttr(filter, 'cb')"
              :ref="`${filter.name}Ref`"
            />
            <button
              v-else-if="
                filter.type === 'button'
                && (filter.requirements || filter.requirements === undefined)
              "
              @click="filter.cb"
              style="border-radius: 0"
            >
              <awesomeIcon
                v-if="filter.icon !== undefined"
                :icon="filter.icon"
              /> {{ filter.label }}
            </button>
            <input
              v-else-if="!['button', 'dropdown'].includes(filter.type)"
              :type="!['user'].includes(filter.type)"
              v-model="filter.model"
              :min="checkAttr(filter, 'min')"
              :max="checkAttr(filter, 'max')"
            />
          </div>
        </slot>
      </div>
    </div>
    <div class="filters-body" ref="filtersBody">
      <div
        class="input"
        v-for="(filter, index) in bodyInputs"
        :key="index"
      >
        <span>{{ filter.label }}</span>
        <div
          class="input-inner"
        >
          <operatorInput
            v-if="filter.operators"
            v-model="filter.operator"
            :allowed="filter.operators"
            :inputType="filter.type"
            ref="operatorInput"
          />
          <inputSuggest
            v-if="filter.type === 'user'"
            :ref="`${filter.name}Ref`"
            v-model="filter.model"
            :roles="filter.roles || []"
            width="100%"
          />
          <inputDropdown
            v-else-if="
              filter.type === 'dropdown'
              && (filter.requirements || filter.requirements === undefined)
            "
            v-model="filter.model"
            :array="checkAttr(filter, 'array')"
            :displayValue="checkAttr(filter, 'displayValue')"
            :defaultValue="checkAttr(filter, 'defaultValue')"
            :defaultIndex="checkAttr(filter, 'defaultIndex')"
            :displayPostfix="checkAttr(filter, 'displayPostfix')"
            :clearable="checkAttr(filter, 'clearable')"
            :clearedDisplayValue="checkAttr(filter, 'clearedDisplayValue')"
            :scroll="checkAttr(filter, 'scroll')"
            :transparent="checkAttr(filter, 'transparent')"
            :align="checkAttr(filter, 'align')"
            :displayPrefix="checkAttr(filter, 'displayPrefix')"
            :cb="checkAttr(filter, 'cb')"
            :requirements="checkAttr(filter, 'requirements')"
            class="input-dropdown-body"
          />
          <multiDropdown
            v-else-if="filter.type === 'multiDropdown'"
            :filterComponent="true"
            v-model="filter.model"
            :filterName="filter.filterName"
            :array="checkAttr(filter, 'array')"
            :displayValue="checkAttr(filter, 'displayValue')"
            :defaultValue="checkAttr(filter, 'defaultValue')"
            :defaultIndex="checkAttr(filter, 'defaultIndex')"
            :displayPostfix="checkAttr(filter, 'displayPostfix')"
            :clearable="checkAttr(filter, 'clearable')"
            :clearedDisplayValue="checkAttr(filter, 'clearedDisplayValue')"
            :scroll="checkAttr(filter, 'scroll')"
            :transparent="checkAttr(filter, 'transparent')"
            :align="checkAttr(filter, 'align')"
            :displayPrefix="checkAttr(filter, 'displayPrefix')"
            :cb="checkAttr(filter, 'cb')"
            :ref="`${filter.name}Ref`"
            style="width:100% !important;"
          />
          <input
            v-if="!['dropdown', 'user', 'multiDropdown'].includes(filter.type)"
            :type="filter.type"
            v-model="bodyInputs[index].model"
            :min="checkAttr(filter, 'min')"
            :max="checkAttr(filter, 'max')"
            @keyup.enter="get(true)"
          />
        </div>
      </div>
      <div class="input buttons filter-buttons" title="Alle filters wissen">
        <button @click="clear()">
          <awesomeIcon icon="times" />
        </button>
        <button @click="clear('refresh')" title="Huidige pagina verversen">
          <awesomeIcon icon="sync" />
        </button>
        <button @click="get(true)" title="Filters toepassen">
          <awesomeIcon icon="search" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { forEach, find } from 'lodash-es';

/* eslint-disable */
export default {
  name: 'TableFilter',
  emits: ['update:model-value'],
  props: {
    mainFunction: {
      type: Function,
      default: () => { },
    },
    name: {
      type: String,
      default: () => `Filters-${new Date().getTime()}${Math.floor(Math.random() * 1000000)}`,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: false,
      bodyHeight: 0,
      disableGeneralInput: false,
      activeFilters: [],
      clearedFlag: false,
    };
  },
  mounted() {
    this.bodyHeight = this.$refs.filtersBody.clientHeight;
    this.$refs.filtersBody.style.height = '0';
    setTimeout(() => {
      this.$refs.filtersBody.style.transition = 'height 0.15s';
    }, 10);
  },
  created() {
    this.$nextTick(() => {
      this.getCookies();
    });

    forEach(this.modelValue, (filter) => {
      filter.defaultOperator = filter.operator;
    });
  },
  watch: {
    filters() {
      this.$nextTick(() => {
        this.getCookies();
      });

      forEach(this.modelValue, (filter) => {
        filter.defaultOperator = filter.operator;
      });
    },
  },
  computed: {
    generalInput() {
      return find(this.modelValue, { name: 'generalInput' });
    },
    bodyInputs() {
      return this.modelValue.filter(input => input.name !== 'generalInput' && input.position !== 'topbar');
    },
    topbarInputs() {
      return this.modelValue.filter(input => input.position === 'topbar');
    },
  },
  methods: {
    get(type) {
      let filter = [];
      this.activeFilters = [];
      let model;

      for (let i = 0; i < this.modelValue.length; i += 1) {
        if (this.modelValue[i].filterName && this.modelValue[i].operator) {
          if (Array.isArray(this.modelValue[i].model)) {
            if (this.modelValue[i].model.length === 0) {
              model = false;
            } else {
              model = this.modelValue[i].model.join(',');
            }
          } else if (typeof this.modelValue[i].model === 'string') {
            model = this.modelValue[i].model.trim();

            if (model === '') {
              model = false;
            }
          } else {
            model = this.modelValue[i].model;
          }

          if (model) {
            filter.push(`${this.modelValue[i].filterName} ${this.modelValue[i].operator} ${this.modelValue[i].model}`);
            this.createCookie(this.modelValue[i].cookie, this.modelValue[i].model);

            if (!this.activeFilters.includes(this.modelValue[i].cookie) && this.modelValue[i].name !== 'generalInput') {
              this.activeFilters.push(this.modelValue[i].cookie);
            }
          } else {
            this.eraseCookie(this.modelValue[i].cookie);
          }

          this.createCookie(`${this.modelValue[i].cookie}Operator`, this.modelValue[i].operator);
        }
      }

      this.$props.mainFunction(type, filter, this.activeFilters);
    },
    disableGeneralHidden(target) {
      if (target.currentTarget.parentElement.querySelector('button')) {
        target.currentTarget.parentElement.firstElementChild.querySelector('button').click();
      } else {
        target.currentTarget.parentElement.firstElementChild.focus();
      }

      this.clear();
      this.toggle(false);
      this.disableGeneralInput = false;
    },
    getCookies() {
      for (let i = 0; i < this.modelValue.length; i += 1) {
        if (this.modelValue[i].cookie) {
          if (this.readCookie(this.modelValue[i].cookie)) {
            this.modelValue[i].model = this.readCookie(this.modelValue[i].cookie);
          }

          if (this.readCookie(`${this.modelValue[i].cookie}Operator`)) {
            this.modelValue[i].operator = this.readCookie(`${this.modelValue[i].cookie}Operator`);
          }
        }
      }
      this.$emit('update:model-value', this.modelValue);
      this.get();
    },
    getValue(input) {
      for (let i = 0; i < this.modelValue.length; i += 1) {
        if (this.modelValue[i].name === input) {
          return this.modelValue[i].model;
        }
      }

      return null;
    },
    setValue(input, value) {
      for (let i = 0; i < this.modelValue.length; i += 1) {
        if (this.modelValue[i].name === input) {
          this.modelValue[i].model = value;
          break;
        }
      }
    },
    getAttr(input, attrName) {
      for (let i = 0; i < this.modelValue.length; i += 1) {
        if (this.modelValue[i].name === input) {
          for (let j = 0; j < this.modelValue[i].attributes.length; j++) {
            if (this.modelValue[i].attributes[j].name === attrName) {
              return this.modelValue[i].attributes[j].value;
            }
          }
        }
      }

      return null;
    },
    checkAttr(filter, attr) {
      const foundAttr = find(filter.attributes, { name: attr });
      if (foundAttr) {
        return foundAttr.value;
      }

      return null;
    },
    clear(type) {
      if (this.disableGeneralInput && type === 'generalSearch') {
        return;
      }

      if (type === 'refresh') {
        this.get();
        return;
      }

      if (type !== 'generalSearch') {
        this.setValue('generalSearch', '');
      }

      forEach(this.modelValue, (filter) => {
        if (!((type === 'generalSearch' && filter.name === 'generalInput') || (type === 'generalSearch' && filter.position === 'topbar')) && filter.position !== 'topbar') {
          filter.operator = filter.defaultOperator;
          filter.model = '';
        }

        if (['user', 'multiDropdown'].includes(filter.type)) {
          this.$refs[`${filter.name}Ref`][0].clear();
        }

        this.eraseCookie(`${filter.cookie}Operator`);
      });

      this.$nextTick(() => {
        this.$refs.operatorInput.forEach((ref) => {
          ref.reset();
        });
      });

      this.$emit('update:model-value', this.modelValue);
      this.get(['refresh', 'generalSearch'].includes(type));
    },
    toggle(newState) {
      if (newState === 'toggle') {
        this.active = !this.active;
      } else {
        this.active = newState;
      }

      this.disableGeneralInput = this.active;

      if (this.active) {
        forEach(this.modelValue, (filter) => {
          if (filter.name === 'generalInput') {
            filter.operator = filter.defaultOperator;
            filter.model = '';
            this.eraseCookie(filter.cookie);
            this.eraseCookie(`${filter.cookie}Operator`);
          }
        });
        this.$refs.filtersBody.style.height = `${this.bodyHeight}px`;
        setTimeout(() => {
          this.$refs.filtersBody.style.overflow = 'visible';
        }, 150);

        if (!this.clearedFlag) {
          this.clearedFlag = true;
          this.get(true);
        }
      } else {
        this.clearedFlag = false;
        this.$refs.filtersBody.style.overflow = 'hidden';
        this.$refs.filtersBody.style.height = '0px';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input-dropdown-body {
  width: 100%;
}
.filters {
  width: 100%;
  height: auto;
  background-color: $color-highlight;
  border-radius: 0;
  padding: 2px;
  box-sizing: border-box;

  .filter-toggle {
    border-radius: 0;
    position: relative;

    .filter-amount {
      font-size: 12px;
      position: absolute;
      top: 58%;
      font-weight: bold;
      left: 70%;
      transform: translate(-50%, -50%);
    }
  }

  .filters-head {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    position: relative;

    .filters-head-side {
      display: flex;
      justify-content: flex-start;
      gap: 2px;
    }

    input[type="text"] {
      width: 300px;
      height: 36px;
      border: none;
      padding: 10px;
      box-sizing: border-box;
      position: relative;

      &:focus {
        outline: none;
      }
    }

    .general-input {
      width: auto;
      height: auto;
      position: relative;

      .hide-general-input {
        width: 100%;
        height: 36px;
        background-color: rgba(0, 0, 0, 0.15);
        position: absolute;
        top: 0;
        left: 0;
        cursor: text;

        &.operator {
          cursor: pointer;
        }
      }
    }

    button {
      border-radius: 0;
    }
  }

  .filters-body {
    width: 100%;
    height: auto;
    overflow: hidden;

    .input {
      width: calc(100% / 5);
      height: 60px;
      padding: 4px 2px 0 0;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      vertical-align: top;

      &:nth-child(5) {
        padding-right: 0;
      }

      span {
        padding-left: 3px;
        font-weight: bold;
      }

      .input-inner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        input {
          border-radius: 0;
          width: calc(100% - 37px) !important;
          height: 36px;
          vertical-align: top;
          width: calc(calc(100% / 5) - 2px);
          outline: none;
          border: none;
          padding: 0 10px;
          box-sizing: border-box;
          font-family: 'Open Sans', sans-serif;

          &:focus {
            box-shadow: none;
          }
        }
      }

      &.buttons {
        flex-direction: row;
        align-items: flex-end;
        float: right;

        button {
          width: calc(50% - 1px);
          height: 36px;
          border-radius: 0;
          background-color: rgba(0, 0, 0, 0.1);

          &:hover {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }

    .filter-buttons {
      padding-right: 0;
      display: flex;
      gap: 2px;
    }
  }
}
</style>
